/* KWD cart drawer renderer.

   Why this exists: the drawer had TWO renderers. assets/theme.js (fired by
   clicking the cart icon) built the line-item HTML correctly. The copy inside
   snippets/ajaxify-cart.liquid (fired after add-to-cart) declared
   `var cartcontent = ''` and then never appended to it, so adding a product
   redrew the drawer as a subtotal floating over an empty list.

   This is now the single renderer for that markup. It deliberately mirrors
   theme.js's structure, class names and money format so the two entry points
   are pixel-identical, and so the existing qtyPlus / qtyMinus / removeThis
   globals in theme.js keep working against it unchanged.

   The ENTHUSIAST / CONNOISSEUR / SOMMELIER skip is inherited from theme.js:
   those are subscription placeholder line items and must not be drawn. */
(function(){
  'use strict';

  var HIDDEN = ['ENTHUSIAST','CONNOISSEUR','SOMMELIER'];

  function esc(s){
    return String(s==null?'':s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function usd(n){ return '$ '+n.toFixed(2); }

  function lineHTML(it){
    var id = it.id,
        qty = it.quantity,
        unit = it.price/100,
        line = unit*qty,
        f = 'updates_'+id;

    return '<div class="ajaxcart__product">'
      + '<div class="grid grid--half-gutters">'
        + '<div class="grid__item one-quarter">'
          + '<a class="ima-jum" href="'+esc(it.url)+'"><img class="img" src="'+esc(it.image)+'" alt="'+esc(it.title)+'"></a>'
        + '</div>'
        + '<div class="grid__item three-quarters">'
          + '<div class="ajaxcart__product-name-wrapper">'
            + '<a href="'+esc(it.url)+'" class="title ajaxcart__product-name h4">'+esc(it.title)+'</a>'
          + '</div>'
          + '<div class="grid--table">'
            + '<div class="grid__item our-giri">'
              + '<div class="ajaxcart__qty"><div class="cart-quantity">'
                + '<input type="button" value="-" onclick="qtyMinus(this)" field="'+f+'"/>'
                + '<input disabled id="'+f+'" type="text" name="updates[]" class="quantity" value="'+qty+'" />'
                + '<input type="button" value="+" onclick="qtyPlus(this)" field="'+f+'"/>'
              + '</div>'
              + '<div class="delete_but"><a onclick="removeThis('+id+');" href="javascript:void(0);" class="removeEsto">Remove</a></div>'
              + '</div>'
            + '</div>'
            + '<div class="grid__item one-half text-right no-padding">'
              + '<div class="price cart-sidebar-price">'+usd(line)
                + '<input type="hidden" class="'+f+'" value="'+unit+'">'
              + '</div>'
            + '</div>'
          + '</div>'
        + '</div>'
      + '</div>'
    + '</div>';
  }

  function render(cart){
    var box = document.getElementById('CartContainer');
    if(!box || !cart) return;

    var items = cart.items || [];
    if(!items.length){
      box.innerHTML = '<p class="ajax_cart--empty-message">Your cart is currently empty.</p>';
      return;
    }

    var rows = '', subtotal = 0;
    for(var i=0;i<items.length;i++){
      var it = items[i];
      subtotal += (it.price/100)*it.quantity;
      if(HIDDEN.indexOf(it.title) !== -1) continue;
      rows += lineHTML(it);
    }

    box.innerHTML =
      '<div class="ajaxcart__inner ajaxcart__inner--has-fixed-footer">'
        + '<div class="ajaxcart__row">'+rows+'</div>'
      + '</div>'
      + '<div class="ajaxcart__footer ajaxcart__footer--fixed">'
        + '<div class="grid--table">'
          + '<div class="grid__item two-thirds"><span class="ajaxcart__subtotal-title h3">Subtotal</span></div>'
          + '<div class="grid__item one-third text-right">'
            + '<span id="sub_totals"><input type="hidden" class="subtotal_val" value="'+subtotal.toFixed(2)+'">'+usd(subtotal)+'</span>'
          + '</div>'
        + '</div>'
        + '<div class="ajaxcart__subtotal"></div>'
        + '<a href="/cart" class="blu">View Cart</a>'
        + '<button type="submit" class="btn btn--full cart__checkout" name="checkout">Check out</button>'
      + '</div>';
  }

  /* Keep an already-open drawer honest when the cart changes elsewhere.
     Skipped for `change` (the drawer's own +/- buttons already update their row
     in place; re-rendering underneath a rapid double-tap would drop a click). */
  document.addEventListener('kwd:cart:updated', function(e){
    var d = e.detail || {};
    if(!d.cart || d.reason === 'change' || d.reason === 'init') return;
    var drawer = document.getElementById('CartDrawer');
    if(drawer && parseInt(drawer.style.width,10) > 0) render(d.cart);
  });

  window.KWDDrawer = { render: render };
})();
